var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595)",
    d: "m0 0h72l16 5 22 7 35 10 44 16 35 16 16 8 24 13 21 13 15 10 16 11 21 16 28 24 15 14 13 13 9 11 9 10 6 5 24 9 19 9 13 8 18 13 10 9 8 7 9 11 10 15 9 19 3 12 1 13v17l-2 28-4 24-8 32-10 36-14 43-13 35-5 15v7l8 10 9 11 4 8 2 8 1 18-2 18-4 12-9 15-8 10-10 9-10 5-17 5-11 2-11 1h-64l-5 27-5 24-8 26-8 14-9 12-9 11-19 19-13 10-10 8-19 13-5 6 1 18-1 64v57l1 10 36 12 36 15 31 12 41 17 18 8 19 10 22 11 22 13 15 10 15 11 10 8 12 11 8 7 7 7 7 8 10 11 13 17 10 14 12 20 11 20 12 28 11 30 16 47 12 36 15 42 11 29 11 26 6 12 2 6h2l4-16 9-29 16-45 33-90 13-36 11-31 12-33 10-25 4-6 3-2h10l12 3 7 3 11 3 6-9 9-24 11-32 5-13 2-8v-8l-5-9-11-11-5-10-2-11v-74l1-12 4-1 45-1h234l40 1 4 4 1 4v16l-1 19-5 30-4 9-6 11-10 13-9 10-10 7-13 6-15 4-11 2-11 1-39 1-6 1-6 20-16 42-12 35-9 21-5 12 1 4 23 11 11 7 4 4 1 2v9l-4 15-12 34-7 21-10 28-16 44-17 47-16 44-15 41-17 47-9 25-21 57-11 31-14 39-10 28-14 37-8 17-9 14-8 10-8 9-11 9-14 9-25 10-16 5-19 3-11 1h-37l-19-3-16-5-18-8-11-6-16-12-14-12-12-13-10-13-9-15-10-18-11-23-14-34-9-25-9-27-2-3-4-1v250l-1 47-1 25-2 15-3 12h-859l-1-17-1-61-1-190h-25l-19-2-21-5-21-9-15-8-13-9-14-12-11-11-13-17-9-15-10-21-6-21-3-17-1-9v-19l3-20 7-23 11-24 13-23 12-20 10-16 16-27 18-30 15-24 6-10 16-25 20-30 9-14 13-19 10-14 13-18 11-14 12-16 14-19 11-14 12-14 3-4h2l2-4 7-7 7-8 7-7 1-2h2l2-4 24-24 8-7 12-11 8-7 16-13 18-13 13-10 19-13 21-12 23-10 19-7 48-13 31-4 4-1 2-7 1-103v-33l-2-4-14-11-11-8-14-12-11-9-13-13-7-8-11-14-8-13-5-11-5-19-8-44-3-7h-8l-14 2-18 1h-19l-17-1-16-4-12-5-11-7-13-13-8-14-5-13-3-13v-17l4-16 7-14 9-12 3-6-1-6-10-24-11-27-8-28-5-27-3-28v-39l2-20 5-28 9-35 9-27 11-26 13-23 4-9-3-5-17-16-31-31-7-8-8-8-7-8-9-9-7-8-11-13-2-4 1-5 5-4 26-8 38-8 26-4 9-1 23-1h36l25 1 36 4 41 7 39 9 43 12 6 1-2-14-4-12-8-17-10-19-16-31-6-13z",
    fill: "#FBCAB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1072)",
    d: "m0 0 2 1v9l2 2 4 18 6 28 6 34 8 40 8 48 8 42 12 74 2 18v33l-3 19-4 18-9 27-14 28-7 9-9 12-8 7-5 2v2l5-1 29-1 3 1 19 1h16l44 1h26l25 1 65-2 14-1 3-13 1-11 6-9 8-7 9-3 12-2 12-1h14l33 2 12 4 7 5 6 12 3 12 1 18 2 8 1 3 12 1 25 1 20 5 12 5 11 6 14 10 9 10 10 15 8 20 4 19v30l-2 14-6 18-9 17-8 11-5 4-5 5-8 7-14 7-21 7-24 4h-141l-8-1-1 53v66l1 154h-446l-1-17-1-61-1-190h-25l-19-2-21-5-21-9-15-8-13-9-14-12-11-11-13-17-9-15-10-21-6-21-3-17-1-9v-19l3-20 7-23 11-24 13-23 12-20 10-16 16-27 18-30 15-24 6-10 16-25 20-30 9-14 13-19 10-14 13-18 11-14 12-16 14-19 11-14 12-14 3-4h2l2-4 7-7 7-8 7-7 1-2h2l2-4 24-24 8-7 12-11 8-7 16-13 18-13z",
    fill: "#70CCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1517,986)",
    d: "m0 0h234l40 1 4 4 1 4v16l-1 19-5 30-4 9-6 11-10 13-9 10-10 7-13 6-15 4-11 2-11 1-39 1-6 1-6 20-16 42-12 35-9 21-5 12 1 4 23 11 11 7 4 4 1 2v9l-4 15-12 34-7 21-10 28-16 44-17 47-16 44-15 41-17 47-9 25-21 57-11 31-14 39-10 28-14 37-8 17-9 14-8 10-8 9-11 9-14 9-25 10-16 5-19 3-11 1h-37l-19-3-16-5-18-8-11-6-16-12-14-12-12-13-10-13-9-15-10-18-11-23-14-34-9-25-9-27-2-3-3-1-1-13-1-52-1-19-2-5-11-9-13-10-5-5-15-11-9-7-10-7v-2l-4-2-7-7-8-7-8-8-12-16-7-10-12-22-5-10-4-13-2-3-4-17-3-17-1-12v-30l4-32 9-52 10-54 13-75 7-36 5-24 2-16 2-5-1-10 9 3 27 14 23 13 18 12 15 11 10 8 12 11 8 7 7 7 7 8 10 11 13 17 10 14 12 20 11 20 12 28 11 30 16 47 12 36 15 42 11 29 11 26 6 12 2 6h2l4-16 9-29 16-45 33-90 13-36 11-31 12-33 10-25 4-6 3-2h10l12 3 7 3 11 3 6-9 9-24 11-32 5-13 2-8v-8l-5-9-11-11-5-10-2-11v-74l1-12 4-1z",
    fill: "#D2E5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,1014)",
    d: "m0 0h10l2 2 3 10 7 20 5 12 5 11 6 16 4 9 7 17 8 17 7 20 9 25 9 23 10 27 11 28 8 19 7 19 6 12 8 20 5 10 8 10 5 2h7l3-1 6-9 6-10 11-28 8-21 8-20 5-12 4-11 10-26 11-30 8-21 6-15 11-31 10-24 14-35 7-17 2-11 7 1 17 6 34 14 31 12 41 17 18 8 3 9-1 5-1 3-2 16-5 24-8 42-13 74-7 38-12 70-3 25v30l3 26 4 15 2 7 3 8 5 12 10 19 9 15 6 7 10 13 11 11 8 7 5 4v2l4 2 10 7 10 8 15 11v2l4 2 10 8 11 9 2 5 1 19 1 65-1 250-1 47-1 25-2 15-3 12h-413l-1-24-1-130v-66l1-53 4-1 5 1h141l24-4 24-8 11-6 11-9 5-5 7-9 8-14 6-14 3-10 2-14v-30l-5-22-7-17-8-12-8-10-11-9-16-9-12-5-20-5-25-1-12-2-3-5-1-6-1-18-3-12-6-12-8-5-10-3-33-2h-14l-19 2-12 3-8 6-6 8-1 2-2 16-3 8-17 2-66 2-22-1h-38l-43-1h-10l-13-1-4-1-30 1h-3v-2l11-8 8-10 9-12 14-28 10-30 4-19 2-15v-33l-3-25-14-84-8-42-6-35-8-41-6-35-6-27-3-13-2-2v-9l5-5 19-13 24-13 30-12 27-8 27-7z",
    fill: "#234580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595)",
    d: "m0 0h72l16 5 22 7 35 10 44 16 35 16 16 8 24 13 21 13 15 10 16 11 21 16 28 24 15 14 13 13 9 11 9 10 6 5 24 9 19 9 13 8 18 13 10 9 8 7 9 11 10 15 9 19 3 12 1 13v17l-2 28-4 24-8 32-10 36-14 43-13 35-5 13-25-5-20-3-71-4-3-3-2-69-3-74-3-22-5-15-8-13-8-7-10-5-21-5-15-2h-65l-12 2-10 7-11 9-8 6-9 8-19 14-17 11-12 9-12 8-14 9-21 12-12 7-23 11-24 10-37 13-25 8-55 14-3 3-2 8-2 43-4 2-30 2-34 2-25 4-22 5h-5l-7-15-10-25-6-16-7-27-5-29-2-21v-39l2-20 5-28 9-35 9-27 11-26 13-23 4-9-3-5-17-16-31-31-7-8-8-8-7-8-9-9-7-8-11-13-2-4 1-5 5-4 26-8 38-8 26-4 9-1 23-1h36l25 1 36 4 41 7 39 9 43 12 6 1-2-14-4-12-8-17-10-19-16-31-6-13z",
    fill: "#234580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1494,272)",
    d: "m0 0h246l30 1 3 2 1 4v233l-3 17-8 18-9 20-8 12-11 13-13 13-16 12-23 12-19 8-13 5-1 4 2 4v69l-1 119-1 20h123l74-1 31-1 13-1h84l10 5 5 5 3 5 3 13v24l-2 16-5 15-8 15-9 12-9 9-13 8-9 4-14 2-13 1h-49l-66-3-22-2-54-1h-138l-96 1-20 1-46 1h-113l-16-4-15-9-11-11-7-10-6-13-4-13-2-12v-38l2-10 4-5 4-2 328-1 1-58 1-138v-12l-1-8-30-14-18-10-12-9-13-11-7-7-7-8-10-13-10-18-7-18-4-20-3-23-1-13v-19l1-14 2-137 2-32 2-3z",
    fill: "#754E9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1072)",
    d: "m0 0 2 1v9l2 2 4 18 6 28 6 34 8 40 8 48 8 42 12 74 2 18v33l-3 19-4 18-9 27-14 28-7 9-9 12-8 7-11 7h-12l-61-5-24-1-18 3-19 7-14 7-11 9-11 11-9 13-5 10-3 14-1 16-2 78-1 19-1 34-1 19h-25l-19-2-21-5-21-9-15-8-13-9-14-12-11-11-13-17-9-15-10-21-6-21-3-17-1-9v-19l3-20 7-23 11-24 13-23 12-20 10-16 16-27 18-30 15-24 6-10 16-25 20-30 9-14 13-19 10-14 13-18 11-14 12-16 14-19 11-14 12-14 3-4h2l2-4 7-7 7-8 7-7 1-2h2l2-4 24-24 8-7 12-11 8-7 16-13 18-13z",
    fill: "#D2E6FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1639,855)",
    d: "m0 0h11v3h123l74-1 31-1 13-1h84l10 5 5 5 3 5 3 13v24l-2 16-5 15-8 15-9 12-9 9-13 8-9 4-14 2-13 1h-49l-66-3-22-2-54-1h-138l-96 1-20 1-46 1h-113l-16-4-15-9-11-11-7-10-6-13-4-13-2-12v-38l2-10 4-5 4-2 328-1 1-2z",
    fill: "#A43680"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1517,986)",
    d: "m0 0h234l40 1 4 4 1 4v16l-1 19-5 30-4 9-6 11-10 13-9 10-10 7-13 6-15 4-11 2-11 1-39 1-6 1-6 20-16 42-12 35-9 21-5 12v5l-15-2-16-4-37-12-16-6-17-7-20-7-17-7-12-6 8-16 15-44 6-14 3-12v-8l-5-9-11-11-5-10-2-11v-74l1-12 4-1z",
    fill: "#FBCBB9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,941)",
    d: "m0 0 3 1 4 4 14 5v2l5 2 8 4 8 6 4 4 13 7 10 3 8 5 13 5 9 3 4 2 19 4 18 3h8l5 1 15-3 28-7 12-4h9l4-12 3-15 2-3h2l3 32 2 25 15 5-2 12-22 54-11 28-10 28-6 15-8 21-11 30-10 25-6 16-6 15-10 26-14 35-7 11-5 7-3 1h-7l-6-3-8-10-7-14-8-20-5-11-10-26-8-19-10-26-10-27-10-26-11-30-4-10-5-11-10-25-5-12-6-15-4-9-5-12-4-12-3-10-4-3 17-2 4-1 3-9h2l1-18 1-33 1-7z",
    fill: "#FBCBB9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,1496)",
    d: "m0 0h14l33 2 12 4 7 5 6 12 3 12 1 18 2 8 1 3 12 1 25 1 20 5 12 5 11 6 14 10 9 10 10 15 8 20 4 19v30l-2 14-6 18-9 17-8 11-5 4-5 5-8 7-14 7-21 7-24 4h-141l-7-2-1-21-1-42v-165l1-2-5-1 3-9 2-16 6-9 8-7 9-3 12-2z",
    fill: "#FCCBB9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1494,272)",
    d: "m0 0h246l30 1 3 2 1 4v167l-58 1-29 1-11 1-88 1h-106l-15 1 2-143 2-32 2-3z",
    fill: "#70CCFD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,1094)",
    d: "m0 0h1l-1 7-11 29-6 17-8 20-11 30-13 34-4 11-8 19-5 13-8 21-12 30-7 11-5 7-3 1h-7l-6-3-8-10-7-14-8-20-5-11-10-26-8-19-10-26-10-27-10-26-11-30-4-10-5-11 1-4 4 5 14 3 10 5 16 3 13 4 21 4 26 1 23-3 21-4 25-6 13-6 13-5 5-4z",
    fill: "#D2E5FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,865)",
    d: "m0 0 5 5 2 13h9l7 3 32 8 11 3 11 2 27 3h13l26-4 22-5 16-5 22-8 10-3 13-2 6 2h3l1-4 3-7h1l2 12-1 70-1 42h-1l-2-20v-12h-2l-4 16-1 6-2 5-2 3-12 2-20 6-14 3-9 2-10 2-7-1-11-1-18-3-15-4-10-3-11-5-16-8-6-2-15-8-5-5-9-6-8-4v-2l-5-1-9-3-4-3v-2l-6 1-1 7-1 33-1 14-1 4h-2z",
    fill: "#EAAF9F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,327)",
    d: "m0 0h65l25 4 16 5 11 8 6 7 7 14 4 15 2 17 3 74 2 71 73 4 25 4 18 4 2 1v9l8 10 9 11 4 8 2 8 1 18-2 18-4 12-9 15-8 10-10 9-10 5-17 5-11 2-11 1h-50l-14-1-2-11-1-20v-41l1-6 2-33 1-38-3-5-1-12v-24l-1-36-1-23-2-32-3-25-2-9-1-6-2-13-3-7v-4h-2l-1-4-4-2-8-5-9-2h-6l-7-1h-9l-15 2-16-1h-10l-7-1-2-1-6 1-12-3h-11l-5 2-8 2-8 6-2-1 8-7 9-6z",
    fill: "#EBB1A0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,458)",
    d: "m0 0 3 1-38 13-18 5-24 6-15 4-4 2-1 12v39l-4 20 2 25 1 37v23l1 27 1 14 1 10v3l-3-1-2-4h-8l-14 2-18 1h-19l-17-1-16-4-12-5-11-7-13-13-8-14-5-13-3-13v-17l4-16 7-14 9-12 3-6-1-7 32-7 20-3 54-3 13-2 2-43 3-10 6-3 52-13z",
    fill: "#EBB1A0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1891,855)",
    d: "m0 0h84l10 5 5 5 3 5 3 13v24l-2 16-5 15-8 15-9 12-9 9-13 8-9 4-14 2-13 1h-49l-25-1-21-2-2-2-4-2 1-8 4-1h3l1-6 6-7 2-2-1-3 1-3 5-1-2-10v-4l5-1 2-9h2l2-5h2v-2l2-1v-2h2v-2l11-6 1-5-5-1v-7l-4-1 6-1-2-2 1-4v-6h2v-3h2v-4h-4l-4-2v-7h2v-3h9l-1-3-2-2z",
    fill: "#922873"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1772,448)",
    d: "m0 0h2v64l-3 17-8 18-9 20-8 12-11 13-13 13-11 8-3-1-11 2-6 3-3 3h-10l-9 4h-8l-8 1v-2l-9-1-7-2-6-2-9-4-1-3-6-3-1-1v-7h2l-1-7 1-2 5-1v-6l-3-1 2-7 3-3h3l-1-3 8-3 1-3h2l-1-3 1-4h2l-1-11 7 1-2-2v-7l7-10 4-2v-2h2v-2h2l2-6 5-5 2-10 4-6v-8l4-5 2-4 5-5 3-4h2v-3l4-2v-2h2l-1-4 5-3 10-1 13-3 9-1h10l5 1 3 2 7 1 2 1 5-1 3 1v2h3l1 4h4l1-5z",
    fill: "#5E418C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1494,272)",
    d: "m0 0h246l30 1 3 2 1 4v167l-58 1-29 1-11 1-88 1h-106l-15 1v-3l14-1 150-2 43-1 2-1 1-8 1-26 1-76 1-26 1-27 2-4h2v-2h-212v-1z",
    fill: "#5AA7F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,1078)",
    d: "m0 0h2l-2 5-4 4v4h5l1-1h5l4 7 2 9 1 12v13l-3 9h2v9l-5 11-4 1-2-6-4-4-1-6-9-1-14-6h-8l-5-1-4 5-8 4-3 6-4 7v2l-3 1-6 10-4 6-4 1v2l5-2 4 1v2l-7 3 1 5-7 2-4 4v4l-13 10-2 4-6 2v7l-3 6 1 4-1 3-4 4-3 2v4h-3l-2 6-7 7h-2l-1 3-2-1-2 5-5 7-6 3h-2l1 6h-2v2l-3 1-1 6 2 3-5 2h-5l-2 9-5 8-4 4h-2v2l-5 1-2 9-4 1-3 5-6 3-3 9-4 3h-2l1 7h-4l-2 4-2 3-5 2-6 12-4 3-2 7-6 5v6h-6l1 6-2 7-8 6-8 4-3 6-1 10-3 3h-4l-2 6 6 3-3 7h-9l-2 7-2 2v4h-2l-2 4-5 2-1 4h-2l1 7-5 1h-2l-3 6h-3l1-5 1-6-5-1 2-9-3 1h-8l2-5 10-17 18-30 15-24 6-10 16-25 20-30 9-14 13-19 10-14 13-18 11-14 12-16 14-19 11-14 12-14 3-4h2l2-4 7-7 7-8 7-7 1-2h2l2-4 24-24 8-7 12-11 8-7 16-13 18-13z",
    fill: "#E0F3FE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1645,640)",
    d: "m0 0h8l-3 3 1 4 1 3v69l-1 119-1 17-11 1h-51v-56l1-138v-20l4-1h34z",
    fill: "#70CCFD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,1014)",
    d: "m0 0h10l2 2 3 10 7 20 5 12 5 11v3h-2l-1-4-5-1-1-4-1-2-4-1v-2l-6-1-3-2-1-3-3-3-4-7-7-3-4 2-7-1-10-7-6 1-2 5h-2v2l-7 5h-2l-1 7-5-2-1 2-3-2h-2v3l4-1-1 5-11 6-4 2-6 2v5l-5 6-5 1-3 9-3 3-4 17 4 10-1 8 1 3v14l3 3v9l2 3 1 12 2 2 1 5-1 7 1 7 1 2v19l3 10v11l-1 2 3 8-1 8 2 4-1 3 3 7-2 6 1 3v7l-2 4v3l5 1 1 3v16l1 16v7l-2 11v3h-2l-2 10-3 9-1 39-2 26-5 24-3 9-1-4 4-16 2-9 2-15v-33l-3-25-14-84-8-42-6-35-8-41-6-35-6-27-3-13-2-2v-9l5-5 19-13 24-13 30-12 27-8 27-7z",
    fill: "#2C508E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,1021)",
    d: "m0 0 7 1 17 6 34 14 31 12 41 17 18 8 3 9-1 5-1 3-2 16-5 24-8 42-13 74-7 38-12 70-3 25v30l3 26 4 15 2 7 3 8 5 12 10 19 9 15 6 7 10 13 11 11 8 7 5 4v2l4 2 10 7 10 8 15 11v2l4 2 10 8 11 9 2 5 1 19 1 65-1 55h-1l-1-67-2-57-2-18-9-7-14-10-17-13-20-16-15-13-20-20-10-14-7-11-8-14v-2h-3l-6-13-6-14-3-11-2-9-3-27v-25l2-19v-7l-1-3 2-12h-2l-1-9 2-9 2-19 2-4 1-9 2-5 2-19h2l-1-3v-14l1-5v-13l4-18 3-25 1-11 2-16 1-14 2-5 1-2-2-7 1-20-2-4 2-8 2-20 4-7h5l-1-6h-2l-2-5-11 2-1-2-4-2-3-4 1-3-8 1-10-2-4-2-7-1-2-2-6-3v-2l-8-1-2-1v-2l-6-1-1-3-7-1-2-2-7-2-13-5-5-5-9-2-1-1-1 4h-3l-1 5-1 2-3 1-2 7-3 5-6 17-5 3-2 9h-2l-2 10-4 10-9 22-8 23-10 26-7 19-5 11-9 25-12 29-8 21-8 20-11 27-5 9-6 11-1 1h-12l-10-5-6-7-8-16-9-21-4-10-5-13-8-20-6-17-5-12-15-39-6-14-7-20-9-25-11-30-1-6 2 3 7 17 8 17 7 20 9 25 9 23 10 27 11 28 8 19 7 19 6 12 8 20 5 10 8 10 5 2h7l3-1 6-9 6-10 11-28 8-21 8-20 5-12 4-11 10-26 11-30 8-21 6-15 11-31 10-24 14-35 7-17z",
    fill: "#2C508E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,1091)",
    d: "m0 0 19 9 22 13 15 10 15 11 10 8 12 11 8 7 7 7 7 8 10 11 13 17 10 14 12 20 11 20 12 28 9 24v3l-6 1-9-5v2l-3 1-3-6-6-4-2-3 1-5 2-3 4 2 7 5h4l-2-11-3-5-9-4-4-1 1 8-5-2-2-2-2-8-5-5-9-6 3-5v-6l-2-2-11 1-3-6-3-1 1-4 1-3h-3l-5-5h-6l-5-6 2-2-3-3-1-8-4-4-1-5-6-2-6-6-1-4-9-7-7-6-4-4-9-6-5-1-1-4-9-3-3-3v-2l-12-3-2-2-10-1h-14l-5-2-6-9-3-6-8-18v-11l2-5 1-1 12 1 1-4z",
    fill: "#E0F4FE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,1848)",
    d: "m0 0h23l3 102 2 51v47h-43l-1-3-1-25v-110l1-60 1-1z",
    fill: "#5AA7F8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,1475)",
    d: "m0 0h3l3 3 3 2 2 4 6 2 2-3 3 1v3h4l1 7 5 6 1 4 1 3-1 2 4-2 5 1 2 4 2 1 9 1 9 3 18 4 25 3h34l5 1h18l9-3h6l4 2h4l1-5h1v10l-3 11-1 2-17 2-66 2-22-1h-38l-43-1h-10l-13-1-4-1-30 1h-3v-2l11-8 8-10 9-12 5-10 3 3 2-3h2l2-7 6-9 6-5h2l1-3z",
    fill: "#2C508E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,1496)",
    d: "m0 0h14l33 2 12 4 7 5 6 12 3 12 1 18 2 8 1 3 12 1 25 1 20 5 12 5 11 6 14 10 9 10 10 15 8 20 4 19v30l-2 14-6 18-9 17-8 11-5 4-5 5-8 7-14 7-21 7-24 4h-141l-7-2v-7h2v-2l10-3 13-3 26-1 4-1h15l41-2h10l3-1h7l6 1h13l22 3h8l10-1v-2l5-1v-2l16-8 9-8 1-2h2l3-9 4-6 6-14 3-25 1-12-1-6-1-14-3-17-3-11-2-3v-4l-3-1v-3h-2v-2l-4-2-9-11-5-5-12-9-14-6-8-3-18-1-14-2-21-1-7-6-3-15 1-11-2-14-4-8-9-3-15-1-6-1h-22l-10 1-19 1-9 1-7 1-5 5-1 20v8l-2 3h-2l1-4-5-1 3-9 2-16 6-9 8-7 9-3 12-2z",
    fill: "#EBB1A0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,1940)",
    d: "m0 0 35 1 3 2 2 87v18h-43l-1-6v-29l2-71z",
    fill: "#5AA7F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1494,272)",
    d: "m0 0h246l30 1 3 2 1 4v114h-1l-1-20-1 6 1 9-1 11-4-3 1-1-1-10v-27l1-6-2-16-4-28-3-12 1-13 4-1v-4l-6-1h-51l-1 4v2l6-1 2 5-5 1-1 4h-2v2h-2v2l-6 3-3 6-5 5-3 14-2 14-1 19 2 30v53l-5 5h-7l3-5 1-31 1-76 1-26 1-27 2-4h2v-2h-212v-1z",
    fill: "#5AB1F4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1517,986)",
    d: "m0 0h234l40 1 4 4v5h-54l-11 1h-63l-23-1-10 1h-13l-17-1h-19l-15-1h-24l-12 1-17-1h-10l-7 1h-11l-8-1h-7l-5 1-1-2v-6l4-1z",
    fill: "#EBB1A0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(995,1073)",
    d: "m0 0 5 1 12 6 2 11-2 5-2 16-5 24-8 42-13 74-7 38-12 70-3 25v30l3 26 4 15 2 7 3 8 5 12 10 19 9 15 6 7 10 13 11 11 8 7 5 4v2l4 2 10 7 10 8 15 11v2l4 2 10 8 11 9 2 5 1 19 1 65-1 55h-1l-1-67-2-57-2-18-9-7-14-10-17-13-20-16-15-13-20-20-10-14-7-11-9-16-12-27-3-12-3-15-2-21v-24l3-35 2-11 5-35 3-16 3-21 1-4 4-26 2-7v-8l5-24 3-22 1-6 1-9 1-5 2-12 1-9 2-4v-7l2-6 1-15 2-7 4-10v-6l-3-1-2-4v-5h-2v-2l-4-2z",
    fill: "#4A73B4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,1252)",
    d: "m0 0 9 3 5 4 4-2 5 1 4 4 5 2 5 5 4 5 9 3 3 9 5 8 2 7-2 9-4 8-4 3-11 3-6 5-5-2-6-4-4-8-5-15-5-13-5-10-2-17z",
    fill: "#E0F4FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,1056)",
    d: "m0 0 2 1-6 7-2 4h-2v16l2 13 1 1 3 24 5 25 2 15 2 6 2 22 4 24 2 8 2 17 3 14 2 21 10 62 3 21 2 31v16l-2 26-5 24-3 9-1-4 4-16 2-9 2-15v-33l-3-25-14-84-8-42-6-35-8-41-6-35-6-27-3-13-2-2v-9l5-5z",
    fill: "#4A73B4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,1530)",
    d: "m0 0h1v8l-2 4-17 2-66 2-22-1h-38l-43-1h-10l-13-1-4-1-30 1h-3v-2l11-8 3-2v3l6-2h3l8-1 16 1 13 2 28 1 8-1 4 1h51l27 1h26l18-1 14-2 7-2z",
    fill: "#486DAC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,1021)",
    d: "m0 0 7 1 17 6 34 14 31 12 14 6-4 1-15-5-3-2-17-5-12-6-11-5-7-3-12-3-9-3-3 1-1-1-1 4h-3l-1 5-1 2-3 1-2 7-3 5-6 17-5 3-2 9h-2l-2 10-4 10-9 22-8 23-10 26-7 19-5 11-9 25-12 29-8 21-8 20-11 27-5 9-6 11-1 1h-12l-10-5-6-7-8-16-9-21-4-10-5-13-8-20-6-17-5-12-15-39-6-14-7-20-9-25-11-30-1-6 2 3 7 17 8 17 7 20 9 25 9 23 10 27 11 28 8 19 7 19 6 12 8 20 5 10 8 10 5 2h7l3-1 6-9 6-10 11-28 8-21 8-20 5-12 4-11 10-26 11-30 8-21 6-15 11-31 10-24 14-35 7-17z",
    fill: "#4D7EC2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,1541)",
    d: "m0 0 4 1 19 1h16l44 1h26l25 1 65-2 13-1-1 6-4 2-1 3-10 1-5 1-11-1-15 1h-41l-15-1h-27l-25-2h-25l-32-2-7-2-29-2v-3l7-1z",
    fill: "#5AA7F8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1631,808)",
    d: "m0 0 5 2 1 5h9l4 3 1 20-1 17-11 1h-15l-26-2v-3l-4-2v-8l1-3h2l3-10 8-2h4v-3l7-6 3-3h5v-2h3z",
    fill: "#5CB5F8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1417,1200)",
    d: "m0 0h10l12 3 7 3 12 3v2l5 2 3 3-1 2h-3v2l-6 3 1 11-4 2-7 1-9 8-6 1-6-1 2-5-1-3-7 7-6-1-1 3-4-1 1-12v-2h-7l1-5 6-16 5-8z",
    fill: "#DFF3FE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(63,1663)",
    d: "m0 0 5 2 5 5 3 5 4 17 6-2 1-2h2v-2l4 1 2 5 1 4-1 3 1 7 1 3v7l3 4v2l4 2 3 5 2 2h2l-1-6 1-4 3-1 5 5 7 5v2l5 2 6 5 4 6 1 3h2l6 9 16 4 16 8 10 7v1l-10-1-16-5-18-8-16-9-11-8-13-11-11-11-13-17-9-15-10-21z",
    fill: "#E0F3FE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,1708)",
    d: "m0 0h1l2 20 1 33 1 13-1 1-1 53v66l1 154h-6v-9l1-4v-36l-1-10v-28l1-43v-71l-1-51-2-22v-18l2-8 1-17z",
    fill: "#5BB5F8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,1774)",
    d: "m0 0 3 1 2 6 4 6v3h2l-2 17 3 8-2 3-3 1-1 6 2-2h3v6l-4 3 1 4 1 1v7l-4 6 1 15h-2v27l-1 5v25l-1 47v26l-1 53h-1l-1-24-1-130v-66l1-53z",
    fill: "#2B4F8D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960,1379)",
    d: "m0 0h1l1 36 3 26 4 15 2 7 3 8 5 12 10 19 9 15 6 7 10 13 11 11 8 7 5 4v2l4 2 10 7 10 8 15 11v2l4 2 10 8 11 9 2 5 1 19 1 65-1 55h-1l-1-67-2-57-2-18-9-7-14-10-17-13-20-16-15-13-20-20-10-14-7-11-9-16-12-27-3-12-3-15-2-21v-24l1-13z",
    fill: "#4972B3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1703,272)",
    d: "m0 0h37l30 1 3 2 1 4v114h-1l-1-20-1 6 1 9-1 11-4-3 1-1-1-10v-27l1-6-2-16-4-28-3-12 1-13 4-1v-4l-6-1-22-1-9-2-24-1z",
    fill: "#5BB5F8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,1091)",
    d: "m0 0 2 3 7 17 8 17 7 20 9 25 9 23 10 27 11 28 8 19 7 19 6 12 8 20 5 10 8 10 5 2h7l3-1 6-9 6-10 3-6 2-1-3 9-5 9-6 11-1 1h-12l-10-5-6-7-8-16-9-21-4-10-5-13-8-20-6-17-5-12-15-39-6-14-7-20-9-25-11-30z",
    fill: "#4B78BA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,1545)",
    d: "m0 0h20l15 2 35 1 47 1 23 1h35l18-1h29l10-1-1 2h-2l-1 3-10 1-5 1-11-1-15 1h-41l-15-1h-27l-25-2h-25l-32-2-7-2-16-1z",
    fill: "#5BB5F8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,1134)",
    d: "m0 0 12 4 4 8 3 7 1 7-4 2-1 2 4 2 1 4-3 2-1 12v4h-3l-4-9-8-11-5-12-1-19z",
    fill: "#E0F4FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,1071)",
    d: "m0 0h1l-1 10-2 10h-2l-1 6v1 5l-4 3-1 7-3 2 1 5 4 1-2 10-3 10-2 5-4 8-2 1-2 7-9 1v3h-2l-1 7-4 6-1-3 10-27 8-21 6-16 7-19 2-5 4-11 2-5z",
    fill: "#2B4F8D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1236,1344)",
    d: "m0 0 2 3 12 36 16 46-1 2-5-6-4-7-5-4-6-18-1-9-4-5-5-5-1-3v-11l-2-6 3-12z",
    fill: "#E0F4FE"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,1021)",
    d: "m0 0 7 1 17 6 34 14 31 12 14 6-4 1-15-5-3-2-17-5-12-6-11-5-7-3-12-3-9-3-3 1-1-1-1 4h-3l-1 5-1 2-3 1-2 7-3 5-6 17-6 3 1-6 11-28 3-7z",
    fill: "#3A4D8D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,1517)",
    d: "m0 0 5 4 8 11 9 10 17 16 2 1v2l4 2 10 7 10 8 15 11v2l4 2 10 8 11 9 2 5 1 19 1 65-1 55h-1l-1-67-2-57-2-18-5-6-18-13-12-10-9-7-13-10-10-9-8-7-15-15-12-16z",
    fill: "#5286C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,1774)",
    d: "m0 0 3 1-1 58-1 37v178h-1l-1-24-1-130v-66l1-53z",
    fill: "#486CAB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1757)",
    d: "m0 0 2 4 1 13-1 1-1 53v66l1 154h-1l-1-14-1-27v-47l-1-182v-9z",
    fill: "#5AA7F8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,1494)",
    d: "m0 0h36l13 1 9 3 8 4 5 4 6 10 4 10 2 14 1 10 5 8 16 2h14l9 3 8 2-3 1-13-3-25-1-12-2-3-5-1-6-1-18-3-12-6-12-8-5-10-3-33-2h-14l-19 2-12 2 2-2 16-4z",
    fill: "#714E9E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,1543)",
    d: "m0 0 5 1v167l1 42 1 19-2-2-1-9-2-62-1-104-1-34-1-16z",
    fill: "#D2E5FC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,1519)",
    d: "m0 0 4 3 4 10 6 9v3h2l3 6 4 5 15 3v1h-29l-6-9-1-12v-10z",
    fill: "#2B4F8D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,1880)",
    d: "m0 0h1l2 70 2 51v47h-3l1-12-1-17-1-5-1-38v-45l-1-25z",
    fill: "#5BB5F8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,1394)",
    d: "m0 0 6 1 2 3-1 7h2v4l1 4h2v3l-7 3v-2l-2 1-2 2-8 1-4-6 1-4 9-15z",
    fill: "#D2E6FD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1716,446)",
    d: "m0 0h58v1l-85 3-81 1h-47v-1l27-1 88-1 11-1z",
    fill: "#486DAC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1703,272)",
    d: "m0 0h37l30 1 3 2 1 4v114h-1l-1-106-4-5-2-5-30-1-9-2-24-1z",
    fill: "#71CCFD"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,1072)",
    d: "m0 0h1l-1 10h-2l-2 10-4 10-9 22-8 23-10 26-1 3h-2l2-11 7-18 16-44z",
    fill: "#4C7BBF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,1019)",
    d: "m0 0 2 3 7 16 5 11 4 10 9 24 4 12-1 3-3-4-14-35-4-9-5-12-4-12-1-5z",
    fill: "#EAB1A0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,1065)",
    d: "m0 0 2 1-3 5-3 9 3 10 4 24 5 29 2 13v8h-1l-7-40-6-27-3-13-2-2v-9l5-5z",
    fill: "#64B2F8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,1517)",
    d: "m0 0 5 4 8 11 9 10 17 16 2 1v2l4 2 10 7 10 8 15 11v2l4 2 10 8 7 6h-3l-16-12-14-11-10-8-13-10-10-9-8-7-15-15-12-16z",
    fill: "#62B4FA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,1024)",
    d: "m0 0 12 4 34 14 31 12 14 6-4 1-15-5-3-2-17-5-12-6-11-5-7-3-12-3-10-4-1-3z",
    fill: "#6C93CA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1219,1317)",
    d: "m0 0h7l3 3 6 18v2l-4-2-9-4-3-1-3-6v-6z",
    fill: "#E0F4FE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,1290)",
    d: "m0 0 2 2 4 10 5 11 6 14 7 11 5 4 2 2-9-1-5-3-4-8-3-10-5-9-5-19z",
    fill: "#2C508E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(917,1602)",
    d: "m0 0 5 5 8 16 4 11 5 22v23l-4 18-4 12-1-3 3-10 2-14v-30l-5-22-7-17-6-9z",
    fill: "#6E4E9D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1687,987)",
    d: "m0 0h104l1 3h-35l-70-2z",
    fill: "#A63980"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,1110)",
    d: "m0 0 2 3 8 22 7 20 7 19 9 22-1 3-13-30-4-12-4-10-2-6-4-3-2-7-1-7-2-8z",
    fill: "#2C508E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,1305)",
    d: "m0 0h1l-1 14-3 6-4 1 1 4-2 6 1 2h-2l-1 4-4 6-2 1v2l-6-1-1-3h-6v-1l10-1 6-11 8-16z",
    fill: "#2C508E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1757)",
    d: "m0 0 2 4 1 13-1 1-1 53h-2l-1-28v-31z",
    fill: "#59A6F7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,1943)",
    d: "m0 0h1l2 87v18h-2l-1-32-1-17v-51z",
    fill: "#5BB5F8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,446)",
    d: "m0 0 5 1v1l-76 2-15 1v-3l14-1z",
    fill: "#5AAEF8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,1014)",
    d: "m0 0h10l2 2 1 8-2-2-1-4-5-1-3 2-26 4h-10v-1l27-7z",
    fill: "#5376B3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,1942)",
    d: "m0 0h1v77l-1 29h-1l-1-6v-29z",
    fill: "#5BB5F8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,1532)",
    d: "m0 0h2l2 21 1 4 3 2 20 1h12l9 3 8 2-3 1-13-3-25-1-12-2-3-5-1-6z",
    fill: "#714D9D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(72,1546)",
    d: "m0 0 2 2v7l-4 13-6 7h-2l2-10z",
    fill: "#E0F4FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,1098)",
    d: "m0 0h2l6 32 4 26v8h-1l-7-40-4-17z",
    fill: "#5BA9F8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,1072)",
    d: "m0 0h1l-1 10h-2l-2 10-4 10-6 14-3 1 2-9 10-24z",
    fill: "#4B71B2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,1520)",
    d: "m0 0 5 1v5l-5 6-7 4h-2l-1-4 6-9z",
    fill: "#DFF2FD"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,1201)",
    d: "m0 0 2 4-1 5h-2l-1 7-2 1-1 5-4 8v9h2l-1 2-3-1v2l-4 3-1-3 13-34z",
    fill: "#2C508E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1773,503)",
    d: "m0 0h1v9l-3 17-8 18-3 3v-5l2-3h2l3-12 1-7 1-1 1-11z",
    fill: "#5572AF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,1024)",
    d: "m0 0 12 4 27 11v2l-6-1-9-4-16-5-8-3-1-3z",
    fill: "#547AB7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,1494)",
    d: "m0 0h36v1l-44 3-16 3-3-1 13-4z",
    fill: "#6C4998"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,1022)",
    d: "m0 0h1l-1 10-11 27-9 23-1-4 12-31 4-10z",
    fill: "#EBB1A0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1008,1078)",
    d: "m0 0 4 2 2 11-2 5-2 16-2 8h-1l1-15 1-9v-9z",
    fill: "#67B7FA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1703,272)",
    d: "m0 0h37l21 1v1l-11 1v1h-14l-9-2-24-1z",
    fill: "#78C6FB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,1276)",
    d: "m0 0 2 4-14 36-3 1 3-10 8-20z",
    fill: "#4E81C7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,1517)",
    d: "m0 0 5 4 8 11 9 10 15 14-2 1-8-7-15-15-12-16z",
    fill: "#5CAAF8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,1118)",
    d: "m0 0 7 2 3 3 7 4v1l-14-1-4-3v-5z",
    fill: "#E4F5FE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1392,980)",
    d: "m0 0h3l6 1-1 3-9 1h-16l-2-2h2v-2h6l3 1z",
    fill: "#922873"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,1032)",
    d: "m0 0 2 3 5 13 4 10 5 11v3h-2l-10-22-3-11z",
    fill: "#4F4B91"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,1167)",
    d: "m0 0 1 3-1 9-4 10-5 12h-2l1-7z",
    fill: "#4E80C5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1430,1201)",
    d: "m0 0 9 2 7 3 10 3v1l-15-1-7-4-7-2z",
    fill: "#FDFDFE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,1526)",
    d: "m0 0 2 4 2 20 5 8 6 1v1h-8l-4-3-2-10z",
    fill: "#486DAC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,1490)",
    d: "m0 0 3 1-4 10-5 4-1-1 1-7 3-6z",
    fill: "#284A86"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(963,1355)",
    d: "m0 0h1v12l-2 18h-1l-1-6v-10l1-11z",
    fill: "#4C7ABD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1645,640)",
    d: "m0 0h8l-5 4h-8v-1h-25v-1z",
    fill: "#A5B5D2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1613,642)",
    d: "m0 0h28l-2 3h-17l-14-1v-1z",
    fill: "#5CB4F8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,1050)",
    d: "m0 0 16 4 14 6-4 1-15-5-3-2-8-2z",
    fill: "#5778B2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1193,1256)",
    d: "m0 0 11 2 2 4v3l-5-1-6-4v-2h-2z",
    fill: "#D2E6FD"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(811,1540)",
    d: "m0 0 2 4 1 7 6 5 3 1v2h-6l-6-9z",
    fill: "#234580"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,1557)",
    d: "m0 0 5 2v2l4 2 10 7 2 4-4-2-9-7-8-7z",
    fill: "#60B1F9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,1572)",
    d: "m0 0 5 1 11 6 4 3 3 1 1 4-5-2-5-4-14-8z",
    fill: "#575EA4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,1092)",
    d: "m0 0h1v16l-3 12h-1l1-15z",
    fill: "#5FB1F9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,1343)",
    d: "m0 0 4 1 6 2 1 4-2 1-8-3z",
    fill: "#E0F4FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,1199)",
    d: "m0 0 2 4-5 14-4 3 3-9z",
    fill: "#4E83C9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,1513)",
    d: "m0 0 3 1 4 9v9l-2-1-3-12z",
    fill: "#6F51A0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,1116)",
    d: "m0 0 1 3-4 11-4 3 1-6 4-10z",
    fill: "#4E82C7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,1316)",
    d: "m0 0 1 2-8 16-4 2 2-4 8-15z",
    fill: "#4A75B6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,1079)",
    d: "m0 0 2 3 3 6-1 3-6-4-2-3h2l1-4z",
    fill: "#3C5294"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,1053)",
    d: "m0 0 2 3 4 9 2 4v3h-2l-7-16z",
    fill: "#48488D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,1062)",
    d: "m0 0 16 6 2 2h-8l-5-3v-2l-5-1z",
    fill: "#709FD9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,1298)",
    d: "m0 0 1 2-6 16-3 1 3-10 4-8z",
    fill: "#4D7DC1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1597,638)",
    d: "m0 0 11 2v1l-20 1-4-3h10z",
    fill: "#EBB1A0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,1047)",
    d: "m0 0h2l1 3-8 4-1 1h-6l5-4z",
    fill: "#5379B6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,1495)",
    d: "m0 0 4 1-3 2-16 3-3-1 13-4z",
    fill: "#6F4A9A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1773,486)",
    d: "m0 0h1v17l-3 8-1-4 2-10z",
    fill: "#234580"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,1327)",
    d: "m0 0h2l-1 4-4 8-3-1 2-5 1-4z",
    fill: "#2C508E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,1262)",
    d: "m0 0 1 2-5 14h-2l1-6 4-9z",
    fill: "#4D7DC1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,1033)",
    d: "m0 0 9 3 8 3v2l-6-1-9-4-2-1z",
    fill: "#6386BD"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1102,619)",
    d: "m0 0h1v12l-1 6h-1l-1-13z",
    fill: "#FCCBB9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(103,1706)",
    d: "m0 0 2 1 3 9-5-1-2-1z",
    fill: "#E0F4FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(101,1495)",
    d: "m0 0h1v8l-6 4v-3z",
    fill: "#E0F4FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1375,981)",
    d: "m0 0h6l3 2v2h-9l-2-2h2z",
    fill: "#932974"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,1089)",
    d: "m0 0 2 2 6 16-1 3-7-17z",
    fill: "#2B4E8C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(777,1249)",
    d: "m0 0h1v6l-3 7-3 1 3-9z",
    fill: "#518AD2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,1167)",
    d: "m0 0 1 3-1 9-5 5 2-9z",
    fill: "#5493DE"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,1218)",
    d: "m0 0 1 2-4 10-3 1 3-10z",
    fill: "#4C7BBE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,1519)",
    d: "m0 0 2 1-2 4h-2l-2 4-3-1 1-3z",
    fill: "#244681"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1031)",
    d: "m0 0 2 1-10 6h-4v-2z",
    fill: "#688CC3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,1021)",
    d: "m0 0 4 2-4 9h-1v-8z",
    fill: "#374484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiter);
export default __webpack_public_path__ + "static/media/waiter.2a80e114341c55217d9f1cf266c8e8ed.svg";
export { ForwardRef as ReactComponent };